var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var _a, _b;
import store from "@/app/store/store";
import { Vue, Component } from "vue-facing-decorator";
import { State, Action } from "vuex-facing-decorator";
import { LoginState } from "@/app/store/modules/login.state";
import { AppConfigState } from "@/app/store/modules/appconfig.state";
import { LoginRequestModel } from "@/app/models/login-request.model";
import { useForm } from 'vee-validate';
import * as yup from 'yup';
import { RecaptchaClient, RecaptchaRequestViewModel, AuthClient } from "@/app/api/battery-portal-api";
import { load } from "recaptcha-v3";
import { Notifier } from "@/common/utils/notifier";
import { HttpHelper } from "@/app/utils/http-helper";
import DOMPurify from 'dompurify';
const loginNamespace = "loginModule";
const appNamespace = "appConfigModule";
const recaptchaClient = new RecaptchaClient(window.apiUrl);
const authClient = new AuthClient(window.apiUrl);
const changeRecaptchaVisibility = (show) => {
    let badge = document.getElementsByClassName("grecaptcha-badge")[0];
    if (!badge)
        return;
    badge.style.visibility = show ? "visible" : "hidden";
};
let LoginVue = class LoginVue extends Vue {
    constructor() {
        super(...arguments);
        // simpletons
        this.userName = "";
        this.password = "";
        this.showPassword = false;
        // SSO state
        this.isCheckingSso = false;
        this.isSsoAvailable = false;
        this.ssoCompanyId = null;
        this.ssoSubdomain = null;
        this.showCompanySelection = false;
        this.selectedCompanyId = null;
        this.ssoCompanies = [];
        this.ssoMessage = "";
        // recaptcha
        this.recaptcha = null;
    }
    // method
    created() {
        this.logout();
        // Check SSO availability for current domain (only if SSO is enabled globally)
        if (this.isSsoEnabledGlobally) {
            this.checkSsoAvailability();
        }
        if (this.appConfigState.recaptchaSiteKey) {
            try {
                load(this.appConfigState.recaptchaSiteKey, { useEnterprise: true }).then(recaptcha => {
                    this.recaptcha = recaptcha;
                    changeRecaptchaVisibility(true);
                });
            }
            catch (ex) {
                console.error(ex);
            }
        }
    }
    ;
    checkSsoAvailability() {
        return __awaiter(this, void 0, void 0, function* () {
            this.isCheckingSso = true;
            try {
                // Check if SSO is available for the current subdomain
                let data = yield authClient.checkSsoAvailability(null);
                if (data.ssoAvailable) {
                    this.isSsoAvailable = true;
                    this.ssoCompanyId = data.companyId;
                    this.ssoSubdomain = data.subdomain;
                    this.showCompanySelection = false;
                    this.ssoMessage = "This organization uses Single Sign-On (SSO) for authentication.";
                }
                else if (data.requiresCompanySelection) {
                    // No subdomain detected - load company list for selection
                    this.showCompanySelection = false;
                    yield this.loadSsoCompanies();
                    this.ssoMessage = "Select your organization to login with SSO.";
                }
                else {
                    // SSO not available
                    this.isSsoAvailable = false;
                    this.showCompanySelection = false;
                }
            }
            catch (ex) {
                console.error("Error checking SSO availability:", ex);
                // Fail gracefully - allow password login
                this.isSsoAvailable = false;
                this.showCompanySelection = false;
            }
            finally {
                this.isCheckingSso = false;
            }
        });
    }
    loadSsoCompanies() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const companies = yield authClient.getSsoEnabledCompanies();
                this.ssoCompanies = companies || [];
                if (this.ssoCompanies.length > 0) {
                    this.isSsoAvailable = true;
                    this.showCompanySelection = true;
                    // Auto-select if only one company
                    if (this.ssoCompanies.length === 1) {
                        this.selectedCompanyId = this.ssoCompanies[0].companyId;
                        this.showCompanySelection = false;
                        this.ssoMessage = `Login with SSO for ${this.ssoCompanies[0].companyName}`;
                    }
                }
            }
            catch (ex) {
                console.error("Error loading SSO companies:", ex);
                this.isSsoAvailable = false;
                this.showCompanySelection = false;
            }
        });
    }
    attemptLogin() {
        const handleSubmitAction = this.handleSubmit((value) => {
            if (!this.appConfigState.recaptchaSiteKey) {
                this.login(new LoginRequestModel(this.userName, this.password, this.returnUrl));
                return;
            }
            if (!this.recaptchaLoaded || !this.recaptcha)
                return;
            try {
                this.recaptcha.execute(`powershieldAssureMainLogin`)
                    .then(token => {
                    if (!token)
                        throw new Error(`Received empty token.`);
                    recaptchaClient
                        .validate(new RecaptchaRequestViewModel({ response: token, action: 'powershieldAssureMainLogin' }))
                        .then(response => {
                        if (!response.isValid) {
                            console.warn("This request has been flagged as suspicious by Google reCaptcha.");
                            //Notifier.onWarning(`This request has been flagged as suspicious by Google reCaptcha. Try reloading the page.`);
                            //return;
                        }
                        this.login(new LoginRequestModel(this.userName, this.password, this.returnUrl));
                    })
                        .catch(ex => {
                        HttpHelper.handleResponse(ex, () => {
                            Notifier.onServerError(ex);
                        });
                    });
                });
            }
            catch (ex) {
                Notifier.onError(`Google reCaptcha: ${ex}`);
            }
        });
        handleSubmitAction();
    }
    ;
    ssoLogin() {
        return __awaiter(this, void 0, void 0, function* () {
            // Determine which company to use for SSO login
            let companyId = this.ssoCompanyId || this.selectedCompanyId;
            let subdomain = this.ssoSubdomain;
            if (!companyId && !subdomain) {
                Notifier.onWarning("Please select your organization");
                return;
            }
            try {
                const returnUrl = this.returnUrl || '/';
                // Build the SSO login URL
                const params = new URLSearchParams();
                if (companyId)
                    params.append('companyId', companyId.toString());
                if (subdomain)
                    params.append('subdomain', subdomain);
                if (returnUrl)
                    params.append('returnUrl', returnUrl);
                const ssoUrl = `${window.apiUrl}/api/auth/ssologin/sso/login?${params.toString()}`;
                // CRITICAL: Use full-page redirect, NOT fetch/AJAX
                window.location.href = ssoUrl;
            }
            catch (ex) {
                console.error("Error initiating SSO login:", ex);
                Notifier.onError("Failed to initiate SSO login. Please try again.");
            }
        });
    }
    togglePasswordVisibility() {
        this.showPassword = !this.showPassword;
    }
    ;
    // computed
    get statusText() {
        return this.loginState.attemptingLogin ? "Working..." : "Login";
    }
    ;
    get returnUrl() {
        let query = this.$route.query;
        if (!query || !query.ReturnUrl || typeof query.ReturnUrl !== 'string')
            return "";
        return DOMPurify.sanitize(window.encodeURIComponent(query.ReturnUrl));
    }
    ;
    loginTitle(isShort) {
        if (isShort)
            return `${this.appConfigState.applicationName ? this.appConfigState.applicationName : "Sign In"}`;
        else
            return `Sign In${this.appConfigState.applicationName ? " | " + this.appConfigState.applicationName : ""}`;
    }
    ;
    get passwordInputType() {
        return this.showPassword ? "text" : "password";
    }
    ;
    get passwordIconClass() {
        return this.showPassword ? "fa fa-eye-slash" : "fa fa-eye";
    }
    ;
    get recaptchaLoaded() {
        return this.recaptcha != null;
    }
    ;
    get isThirdPartyAuth() {
        return store.getters["appConfigModule/isThirdPartyAuth"];
    }
    get isSsoEnabledGlobally() {
        return this.appConfigState.ssoEnabled === true;
    }
    get isDevelopmentOrStaging() {
        var _a;
        const env = ((_a = this.appConfigState.environmentName) === null || _a === void 0 ? void 0 : _a.toLowerCase()) || "production";
        return env === "development" || env === "staging";
    }
};
__decorate([
    State(appNamespace),
    __metadata("design:type", typeof (_a = typeof AppConfigState !== "undefined" && AppConfigState) === "function" ? _a : Object)
], LoginVue.prototype, "appConfigState", void 0);
__decorate([
    State(loginNamespace),
    __metadata("design:type", typeof (_b = typeof LoginState !== "undefined" && LoginState) === "function" ? _b : Object)
], LoginVue.prototype, "loginState", void 0);
__decorate([
    Action("login", { namespace: loginNamespace }),
    __metadata("design:type", Object)
], LoginVue.prototype, "login", void 0);
__decorate([
    Action("logout", { namespace: loginNamespace }),
    __metadata("design:type", Object)
], LoginVue.prototype, "logout", void 0);
LoginVue = __decorate([
    Component({
        name: "LoginVue",
        setup() {
            const { errors, handleSubmit, defineInputBinds } = useForm({
                validationSchema: yup.object({
                    username: yup.string().trim().required(),
                    password: yup.string().trim().required(),
                }),
            });
            const usernameVal = defineInputBinds('username');
            const passwordVal = defineInputBinds('password');
            return {
                errors,
                handleSubmit,
                usernameVal,
                passwordVal
            };
        }
    })
], LoginVue);
export default LoginVue;
